<template>
  <button
    :class="[
      'button-tab',
      {
        'button-tab--selected': isSelected,
        'button-tab--unselected': !isSelected
      }
    ]"
    @click="handleClick"
    :disabled="disabled"
  >
    <span class="button-tab__text">
      {{ text }}
    </span>
  </button>
</template>

<script>
export default {
  name: "ButtonTab",

  /**
   * Component props definition
   */
  props: {
    /**
     * Text content to display in the tab
     * @type {String}
     */
    text: {
      type: String,
      required: true,
    },

    /**
     * Whether the tab is currently selected
     * @type {Boolean}
     */
    isSelected: {
      type: Boolean,
      default: false,
    },

    /**
     * Whether the tab is disabled
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * Unique value for this tab (used for identification)
     * @type {String|Number}
     */
    value: {
      type: [String, Number],
      required: true,
    },
  },

  /**
   * Component methods
   */
  methods: {
    /**
     * Handles tab click event
     * Emits the tab value to parent component
     */
    handleClick() {
      if (!this.disabled) {
        this.$emit('tab-click', this.value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .button-tab {
    height: rem(47);
    border: 1px solid color(nespressoBrown);
    border-radius: rem(56);
    padding: rem(8) rem(24);
    font-family: 'Nespresso Lucas', sans-serif;
    font-size: rem(20);
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: rem(1);
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: fit-content;

    &:focus {
      outline: none;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    // Selected state - filled background
    &--selected {
      background-color: color(nespressoBrown);
      border-color: color(white);
      
      .button-tab__text {
        color: color(white);
      }

      &:hover:not(:disabled) {
        background-color: darken(color(nespressoBrown), 5%);
      }
    }

    // Unselected state - transparent background
    &--unselected {
      background-color: transparent;
      border-color: color(nespressoBrown);
      
      .button-tab__text {
        color: color(nespressoBrown);
      }

      &:hover:not(:disabled) {
        background-color: rgba(color(nespressoBrown), 0.1);
      }
    }

    &__text {
      transition: color 0.3s ease;
    }

    // Responsive design for mobile
    @include media-breakpoint-down(md) {
      height: rem(40);
      padding: rem(6) rem(16);
      font-size: rem(16);
      letter-spacing: rem(0.8);
    }

    @include media-breakpoint-down(sm) {
      height: rem(36);
      padding: rem(4) rem(12);
      font-size: rem(14);
      letter-spacing: rem(0.6);
    }
  }
}
</style>